import { useAnalytics } from '@magnetic/analytics';
import { useClassNames } from '@magnetic/hooks';
import React, { forwardRef, useCallback } from 'react';
import { TagFrame } from '../frame/index.js';
import './style.css.js';

const SelectableTag = forwardRef(
  ({
    analytics,
    children,
    className,
    onClick,
    prefix,
    selected = false,
    size,
    wrap,
    ...props
  }, ref) => {
    const classNames = useClassNames(
      "mds-rebuild-selectable-tag",
      { "mds-rebuild-selectable-tag-selected": selected },
      className
    );
    const { sendAnalytics } = useAnalytics();
    const handleAnalytics = useCallback(() => {
      var _a;
      if (analytics == null ? void 0 : analytics.events.includes("click")) {
        sendAnalytics({
          ...analytics,
          component: "tag",
          event: "click",
          data: {
            ...analytics.data,
            button: Boolean((_a = analytics.data) == null ? void 0 : _a.buttonCta),
            selected
          }
        });
      }
      onClick == null ? void 0 : onClick();
    }, [analytics, onClick, selected, sendAnalytics]);
    return /* @__PURE__ */ React.createElement(TagFrame, {
      as: "button",
      className: classNames,
      onClick: handleAnalytics,
      prefix,
      ref,
      role: "button",
      size,
      wrap,
      ...props
    }, children);
  }
);
SelectableTag.displayName = "Tag.Selectable";

export { SelectableTag };
//# sourceMappingURL=index.js.map
